module.exports = __webpack_public_path__ + "static/img/Qcon1@2x.6e8bf69a.png";